import { isProduction } from '@utils'

export const constructionTemplateQuickLinks = [
{
    title: 'document.nav.constructionTemplate',
    route: '/document/construction-templates',
    permission: 'general',
    visible: () => true
  }
]

export const akhCardQuickLinks = [
{
    title: 'document.nav.akhCard',
    route: '/document/akh-card',
    permission: 'general',
    visible: () => true
  }
]